module.exports = __webpack_public_path__ + "dist/fonts/roboto/Roboto-Regular-webfont.woff";


//////////////////
// WEBPACK FOOTER
// ./dist/fonts/roboto/Roboto-Regular-webfont.woff
// module id = 1610
// module chunks = 0